import { render, staticRenderFns } from "./new-back-money-student.pug?vue&type=template&id=f5fe750c&lang=pug&"
import script from "./new-back-money-student.ts?vue&type=script&lang=ts&"
export * from "./new-back-money-student.ts?vue&type=script&lang=ts&"
import style0 from "./new-back-money-student.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports